module.exports = __webpack_public_path__ + "img/2013-2.82fedd54.jpg";